import { css, Global, useTheme } from '@emotion/react';
import React, { PropsWithChildren, memo } from 'react';
import N11Meta from '~/features/navigation/components/metas/n11-meta/n11-meta.component';
import N21Header from '~/features/navigation/components/headers/n21-header/n21-header.component';
import { N61Footer } from '~/features/navigation/components/footers/n61-footer/n61-footer.component';
import { StyledCheckoutWrapper, StyledMain } from '../../styled';
import { usePage } from '~/templates/pages';
import { CheckoutFooter, CheckoutHeader } from '~/features/checkout';
import { useMedia } from 'react-use';
import { queries } from '$theme';
import SearchPage from '~/templates/pages/components/SearchPage';

const SolidAshGlobalStyles = () => {
    const { colors, fonts, focus, highlight } = useTheme();

    return (
        <Global
            styles={css`
                html {
                    background-color: ${colors.light};
                }

                body,
                input {
                    font-family: ${fonts.body};
                }

                *::selection {
                    background: ${highlight.background};
                    color: ${highlight.color};
                }

                *:focus-visible {
                    outline-offset: ${focus.outlineOffset};
                    outline-style: ${focus.outlineStyle};
                    outline-color: ${focus.outlineColor};
                    outline-width: ${focus.outlineWidth};
                }
            `}
        />
    );
};

const SolidAshLayout = memo(
    ({ children }: PropsWithChildren<Record<never, never>>): JSX.Element => {
        const { type } = usePage();
        const isCheckout = type === 'p100CheckoutPage';
        const isSearchPage = type === ('m170searchPage' as unknown);
        const isMobile = !useMedia(queries.md, false);
        const SearchComponentWrapper = isSearchPage && isMobile ? SearchPage : React.Fragment;

        if (isCheckout) {
            return (
                <>
                    <SolidAshGlobalStyles />
                    <StyledCheckoutWrapper>
                        <CheckoutHeader />
                        <StyledMain>{children}</StyledMain>
                        <CheckoutFooter />
                    </StyledCheckoutWrapper>
                </>
            );
        }

        return (
            <>
                <SolidAshGlobalStyles />
                <N11Meta />
                <N21Header />
                <SearchComponentWrapper>
                    <StyledMain id="content">{children}</StyledMain>
                    <N61Footer />
                </SearchComponentWrapper>
            </>
        );
    }
);

export default SolidAshLayout;
